/* key-features.js — the Key features block (index.html, features.html; brand-SERP lane 2026-10-12).
   Marks every [data-live] block .is-live while it is on screen, so key-features.css plays its motion only then (and replays
   it when the block comes back into view). No IntersectionObserver: nothing is marked and every visual rests in its
   finished frame, which is also what a visitor without JS sees. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var els = document.querySelectorAll('[data-live]');
  if (!els.length) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting); });
  });
  Array.prototype.forEach.call(els, function (el) { io.observe(el); });
})();
